import React from 'react';
import { Row, Col } from 'antd';
import DetailItem from '../../../CSIComponents/DetailItem';

interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    disableTabPanes?: void | any,
    detail?: any,
    cancelAndSave?: void | any,
    tableCurrentData?: any,
    scheduleAndChargeData?: void | any,
    detailData?: void | any,

}
const AccessibilityAndSecurityDetail = (props: propsTypes) => {
    const detailData = [
        
        { label: 'Type', value: props.detailData.type, span: 6 },
        { label: 'Type Detail', value: props.detailData.typedetail, span: 12 },
        { span: 6 },
        { label: 'Description', value: props.detailData.description, span: 18},

    ]
    return (
        <>
            <Row gutter={24}>
                {detailData.map((item, i) => {
                    return (
                        <>

                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }
                        </>

                    )
                })
                }
            </Row>

        </>
    )
}

export default AccessibilityAndSecurityDetail;